import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { AgGrid } from '../AgGrid';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { getOrdersColumnDefinitions } from '../../helpers';
import RequestNewOrdersButton from '../RequestNewOrdersButton';
import { BulkAssignDialog } from '../BulkAssignDialog';
import { AppContext } from '../../AppContext';
import { bulkAssignOrdersToQa } from '../../services';
import ROLES, { hasPermission } from '../../helpers/roles';
import { Autocomplete } from '../Autocomplete';
import { parseNumberInputValue } from '../../helpers';

// SERVICES
import { getQaUserOptions, getQaTimeTrackingData } from '../../services';

const styles = theme => ({
  input: {
    background: 'transparent',
    '&:focus': {
      outline: 'none',
    },
    alignSelf: 'stretch',
  },

  textInput: {
    fontSize: 18,
    border: '1px solid #aaa',
    borderRadius: 5,
    padding: 10,
  },
});

export const QaTimeTrackingGrid = withRouter(
  withStyles(styles)(({ classes }) => {
    const {
      state: { roles },
    } = useContext(AppContext);

    const columnDefinitions = getOrdersColumnDefinitions('qaTimeTracking', 'admin');
    const [timeTrackingData, setTimeTrackingData] = useState(null);
    const [qaUserOptions, setQaUserOptions] = useState(null);
    const [loadingData, setLoadingData] = useState(false);

    const [selectedQaUserOption, setSelectedQaUserOption] = useState(null);
    const [minuteThreshold, setMinuteThreshold] = useState(60);

    const getQaTimeTrackingDataAsync = async () => {
      setLoadingData(true);
      setTimeTrackingData(null);

      try {
        let data = await getQaTimeTrackingData({
          userId: selectedQaUserOption?.aspNetUserId,
          minuteThreshold,
        });
        setTimeTrackingData(data);
      } catch (error) {
        console.log(error);
      }

      setLoadingData(false);
    };

    const getQaUserOptionsAsync = async () => {
      try {
        let qaList = await getQaUserOptions();
        setQaUserOptions(qaList);
      } catch (error) {
        console.log(error);
      }
    };

    const updateMinuteThreshold = evt => {
      const { value } = evt.target;

      const parsed = parseNumberInputValue(value, 0);

      setMinuteThreshold(parsed);
    };

    useEffect(() => {
      // whenever either option changes, refetch data
      getQaTimeTrackingDataAsync();
    }, [minuteThreshold, selectedQaUserOption]);

    useEffect(() => {
      getQaUserOptionsAsync();
    }, []);

    return (
      <div className={cn('flex-1', 'card', 'border-left-green', 'col-center-center')}>
        <div className="row-start-center align-stretch">
          <Autocomplete
            containerStyles={{ width: 'auto', marginRight: 20 }}
            controlStyles={{ width: 200 }}
            placeholder="User"
            options={qaUserOptions}
            onChange={setSelectedQaUserOption}
            isClearable
            value={selectedQaUserOption}
          />

          <span className="mr-10">Minute Threshold:</span>
          <input
            className={cn(
              classes.input,
              classes.textInput,
              // !!error && classes.textInputError,
              // isDisabled && classes.disabledInput,
            )}
            value={minuteThreshold === null ? 0 : minuteThreshold.toString()}
            onChange={updateMinuteThreshold}
            type={'number'}
            style={{
              height: 27, // matching the Date input height
            }}
          />
        </div>

        <AgGrid
          gridData={timeTrackingData}
          columnDefs={columnDefinitions}
          redirectOnClick={false}
          editOnClick={false}
        />
      </div>
    );
  }),
);

QaTimeTrackingGrid.propTypes = {};
